var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"fullscreen"}},[_c('div',[_c('Countdown',{attrs:{"fullscreen":"true"}}),_c('div',{staticClass:"events-fancy"},[_c('Live')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }